import { render, staticRenderFns } from "./SessionExpiredModal.vue?vue&type=template&id=1cc370be&scoped=true"
import script from "./SessionExpiredModal.vue?vue&type=script&lang=ts"
export * from "./SessionExpiredModal.vue?vue&type=script&lang=ts"
import style0 from "./SessionExpiredModal.vue?vue&type=style&index=0&id=1cc370be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc370be",
  null
  
)

export default component.exports